'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.checkNetwork = exports.NETWORK_CHECK_TIMEOUT_MS = undefined;

var _enviro = require('enviro');

var _enviro2 = _interopRequireDefault(_enviro);

var _noAuthApiClient = require('hub-http/clients/noAuthApiClient');

var _noAuthApiClient2 = _interopRequireDefault(_noAuthApiClient);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NETWORK_CHECK_TIMEOUT_MS = exports.NETWORK_CHECK_TIMEOUT_MS = 5000;

var getHostName = function getHostName() {
  return _enviro2.default.deployed() ? 'app' : 'local';
};

var getDomainSuffix = function getDomainSuffix() {
  return _enviro2.default.isQa() ? 'qa' : '';
};

var checkNetwork = exports.checkNetwork = function checkNetwork() {
  return _noAuthApiClient2.default.get('https://' + getHostName() + '.hubspot' + getDomainSuffix() + '.com/live-messages/is-the-internet-up.txt', {
    timeout: NETWORK_CHECK_TIMEOUT_MS,
    query: { rnd: Math.random() }
  }).then(function () {
    return { online: true };
  }, function (error) {
    return { online: false, error: error };
  });
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-infrastructure/static-1.19/js/http/clients/checkNetwork.js
// module id = 789
// module chunks = 2 3